import { render, staticRenderFns } from "./SwCalendar.vue?vue&type=template&id=548e959f"
import script from "./SwCalendar.vue?vue&type=script&lang=js"
export * from "./SwCalendar.vue?vue&type=script&lang=js"
import style0 from "./SwCalendar.vue?vue&type=style&index=0&id=548e959f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports